import React from 'react';
import HeaderFooterHOC from '../HOC/HeaderFooterHOC';
const Custom = (props) => {

    if ( props.page.type === "externalLink" ) {

        if ('ontouchstart' in document.documentElement) {

            location.replace(props.page.external_url);

        } else {

            let win = window.open(props.page.external_url, 'download');
            if(win) {
                win.focus();
            }
        }

    }

    const content = (props.page.page_content) ? props.page.page_content.page_content : '';
    return( <div dangerouslySetInnerHTML={{__html: content}} />)

}

export default HeaderFooterHOC(Custom);
